
import React from 'react';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Home'
import { Cart } from './Components/Cart';
import LogIn from './Pages/LogIn';
import Product from './Pages/Product';
import AboutUs from './Pages/AboutUs';
import SignUp from './Pages/SignUp';
import Footer from './Components/Footer/Footer';
import Tcg from './Pages/Tcg';
import TcgAccessories from './Pages/TcgAccessories';
import BoardGames from './Pages/BoardGames';
import ContactUs from './Pages/ContactUs';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ReturnsPolicy from './Pages/ReturnsPolicy';
import TermsOfService from './Pages/TermsOfService';
import Profile from './Pages/Profile';
import { Checkout } from './Components/Cart';
import { CartProvider, useCart } from './Components/Cart'
import { AuthProvider } from './Context/AuthContext'
import GoogleAnalytics from './Components/GoogleAnalytics/GoogleAnalytics'

const CartToast = () => {
  const { notification, dismissNotification } = useCart()
  if (!notification) return null
  return (
    <div className="cart-toast">
      <span>{notification}</span>
      <button onClick={dismissNotification} className="cart-toast-close">&times;</button>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
    <CartProvider>
    <CartToast />
    <div className="app-layout">
      <BrowserRouter>
        <GoogleAnalytics />

        <Navbar />
        <main className="app-content">
        <Routes>

          <Route path='/' element={<Home />} />
          <Route path='/AboutUs' element={<AboutUs />} />
          <Route path='/Tcg' element={<Tcg category="tcg" />} />
          <Route path='/TcgAccessories' element={<TcgAccessories />} />
          <Route path='/BoardGames' element={<BoardGames category="board_games" />} />

          <Route path='/Product' element={<Product />}>
            <Route path=':productID' element={<Product />} />
          </Route>

          <Route path='/Cart' element={<Cart />} />

          <Route path='/LogIn' element={<LogIn />} />
          <Route path='/SignUp' element={<SignUp />} />
          <Route path='/Profile' element={<Profile />} />

          <Route path='/ContactUs' element={<ContactUs />} />
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
          <Route path='/ReturnsPolicy' element={<ReturnsPolicy />} />
          <Route path='/TermsOfService' element={<TermsOfService />} />
          <Route path='/Checkout' element={<Checkout />} />

        </Routes>
        </main>

        <Footer />

      </BrowserRouter>
    </div>
    </CartProvider>
    </AuthProvider>
  );
}

export default App;
